import { Link } from "react-router-dom";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";

export default function SeoBreadcrumbs({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav className="seo-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.href}-${index}`}>
              {isLast ? (
                <span aria-current="page">{item.label}</span>
              ) : (
                <Link
                  to={item.href}
                  onClick={() =>
                    trackSeoPageEvent(SEO_ANALYTICS_EVENTS.RELATED_LINK_CLICKED, {
                      href: item.href,
                      source: "breadcrumb",
                    })
                  }
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
